import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import { withRouter } from "react-router-dom";
import Demo from "../components/Demo/demo";
import MainLayout from "../components/MainLayout/MainLayout";

const routes = [
  // { name: "home", path: "/testing", component: Demo },
  { name: "layout", path: "/", component: MainLayout },
  { name: "not-found", path: "**", component: Demo },
];

export const routeArray = (() => {
  let routeArray = [];
  routes.forEach((route) => {
    routeArray.push({
      ...route,
      path: route.path || `/${route.name}`,
      component: route.component,
      exact: true,
    });
  });
  return routeArray;
})();

class Router extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      console.log(
        `Previous Route - "${prevProps.location.pathname}" ---> New Route - "${this.props.location.pathname}"`
      );
    }
  }

  render() {
    return (
      <React.Fragment>
        <Switch>
          {routeArray.map((r, i) => (
            <Route
              path={r.path}
              render={(props) => <r.component {...this.props} {...props} />}
              key={i}
              exact
            />
          ))}
          {/* <Route component={AsyncPageNotFound} /> */}
        </Switch>
      </React.Fragment>
    );
  }
}

export default withRouter(Router);
